import { Box, Divider, Grid } from "@mui/material";
import React from "react";

export default function VerifyVehicle({ formObj, handleFormChange, vehicle }) {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <React.Fragment>
            <Box mt={2}>
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        By using MyInfo, you allow<span className="text-bold mx-1">Web Master Consultancy Pte Ltd</span>(UEN: 199802145E) and its application<span className="text-bold mx-1">iauto.sg</span>to retrieve your personal and vehicle related data from the Singapore Government’s MyInfo service for the following purposes:
                    </Grid>
                    <Grid item sm={12} >
                        <div className={'grey-card'}>
                            <div className="text-bold">Purpose: </div>
                            <ol style={{ padding: 5, paddingInline: 18, margin: 0, fontWeight: 400 }}>
                                <li>To pre-fill your vehicle information for an advertisement listing.</li>
                                <li>To validate your ownership of the vehicle provided.</li>
                            </ol>
                        </div>
                    </Grid>
                    <Grid item sm={12} >
                        The following information will be retrieved from MyInfo (via Singpass):
                        <ul style={{ padding: 5, paddingInline: 18, margin: 0, fontWeight: 400 }}>
                            <li>Name (will not be displayed publicly)</li>
                            <li>Vehicle Registration Number (will not be displayed publicly)</li>
                            <li>Vehicle Make</li>
                            <li>Vehicle Model</li>
                            <li>Year of Manufacture</li>
                            <li>Vehicle Registration Date</li>
                            <li>Vehicle COE Expiry Date</li>
                            <li>Vehicle No of Transfer</li>
                        </ul>
                    </Grid>
                    <Grid item sm={12} ><Divider /></Grid>
                    <Grid item sm={12} >
                        By proceeding, you consent to the release of the above information from MyInfo to<span className="text-bold mx-1">Web Master Consultancy Pte Ltd</span>for the stated purposes.
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    )
}